import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { isPrintMode } from "core/model/utils/urls";
// TODO: move useMedia / responsive utils into core or inject from app
// eslint-disable-next-line no-outside-core-imports/no-outside-core-imports
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Shared condition for hiding Crisp and Salesforce chat.
 * Returns true when chat should be deactivated (hidden): print mode,
 * or on care provider app when (mobile and not on auth page) or on admissions.
 */
export function useShouldDeactivateCustomerSupportChat(): boolean {
  const { app } = useEnvContext();
  const { isMobile } = useMedia();
  const location = useLocation();

  return useMemo(() => {
    if (isPrintMode()) return true;
    if (app !== APP_CAREPROVIDER) return false;

    const { pathname } = location;
    const isCareproviderAuthPage = pathname.includes("/careprovider/auth");
    const isCareproviderAdmissions = pathname.includes(
      "/careprovider/admissions",
    );

    return (isMobile && !isCareproviderAuthPage) || isCareproviderAdmissions;
  }, [app, isMobile, location]);
}
